<section>
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12 mt-5">
                <img src="assets/img/404-error.png" class="img-404 centrar">
                <h3 class="text-center text-uppercase mt-3">{{localization.page404Title}}</h3>
                <h5 class="text-center mt-3 mb-5">{{localization.page404Text}}</h5>
                <div class="d-flex justify-content-center">
                    <button class="btn btn-orange btn-lg" type="button" (click)='onReturnClicked()'>
                        Regresar al inicio
                    </button>
                </div>
            </div>
        </div>
    </div>
</section>
